import { default as BuiltInTool } from './definition.js'

export { BuiltInTool as default }